import React from 'react';
import PointerArrowLine from '../../../assets/images/dashboard/pointer-arrow-line.svg';
import EmptyDashboardImage from '../../../assets/images/empty/empty-dashboard-image.svg';

const EmptyDashboard = () => (
  <>
    <img src={PointerArrowLine} alt="" className="hidden lg:block absolute top-4 right-8 lg:right-14" />
    <div className="text-2xl text-center text-primary mt-[69px]">
      <p className="font-[600]">
        Your dashboard is empty!
      </p>
      <p>
        Try to add a new element to the dashboard.
      </p>
    </div>
    <div className="lg:max-w-[615px] lg:max-h-[510px] max-h-[300px] mt-[30px] lg:mt-[69px]">
      <img src={EmptyDashboardImage} alt="" className="w-full h-full object-contain" />
    </div>
  </>
);

export default EmptyDashboard;
